
export const isAuthenticatedSelector = (state) => state.auth.isAuthenticated;

export const authTypeSelector = (state) => state.auth.authType;

export const userInfoSelector = (state) => state.auth.userInfo;

